/** @format */

import React from "react"
import {
	ActionButton,
	BoostAutoButton,
	ButtonsContainer,
	Description,
	HeaderContainer,
	HeaderWrapper,
	HeadingContainer,
	MarketName,
} from "./DashboardDistributionHeader.styled"
import { DistributionHeaderProps } from "./DashboardDistributionHeader.types"

import { GetQueryValues } from "_shared/helpers/routerHelper"
import { useRelativeRouter } from '_shared/hooks/useRelativeRouter'
import useQuickRepartitionStore from "_stores/quickRepartition/quickRepartition"


const DashboardDistributionHeader = (props: DistributionHeaderProps) => {
	const { marketLabel, isLoading, isEligibleAutoSelection } = props;
	const { clearStore } = useQuickRepartitionStore();
	const router = useRelativeRouter();
	const marketId = GetQueryValues(router.asPath).marketId;
	const productId = GetQueryValues(router.asPath).productId;
	const networkId = GetQueryValues(router.asPath).networkId;
	const contractId = GetQueryValues(router.asPath).contractId;
	const quickRepartitionLink = networkId
		? `quickDispatch?networkId=${networkId}&marketId=${marketId}&productId=${productId}`
		: `quickDispatch?contractId=${contractId}&marketId=${marketId}&productId=${productId}`;

	return (
		<>
			<HeaderContainer>
				<HeaderWrapper>
					<HeadingContainer>
						<MarketName isLoading={isLoading}>{marketLabel} Répartition</MarketName>
						<Description isLoading={isLoading}>
							Utilisez le tableau ci-dessous pour répartir manuellement vos
							boosts.
						</Description>
					</HeadingContainer>
				</HeaderWrapper>
				<ButtonsContainer>
					<ActionButton
						isLoading={isLoading}
						disabled={isLoading}
						kind="primary"
						size="large"
						tag="button"
						variant="normal"
						testID="button-quick-repartition"
						onClick={() => {
							clearStore();
							router.push(quickRepartitionLink)
						}}
						onPointerEnterCapture={undefined}
						onPointerLeaveCapture={undefined}
					>
						Répartition rapide
					</ActionButton>
					{isEligibleAutoSelection &&
					<BoostAutoButton
						isLoading={isLoading}
						disabled={isLoading}
						kind="tertiary"
						variant="normal"
						size="large"
						tag="button"
						testID="button-automatic-boost"
						onClick={() => {
							router.push(`changeDistributionMode?networkId=${networkId}&marketId=${marketId}&productId=${productId}`)
						}}
						onPointerEnterCapture={undefined}
						onPointerLeaveCapture={undefined}
					>
						Mode Boost Automatique
					</BoostAutoButton>}
				</ButtonsContainer>
			</HeaderContainer>
		</>
	)
}

export default DashboardDistributionHeader
